/**
 * Prevent echeckpoint plugin from removing WooCommerce notices
 * 
 * The echeckpoint plugin's checkAndUpdateBanner function runs every second
 * via setInterval and removes all notices (coupon messages, error messages, etc.)
 * This code intercepts DOM removal methods to prevent notices from being deleted.
 * Also prevents duplicate notices from being added.
 */

(function() {
    if (typeof document === 'undefined') {
        return;
    }
    
    const noticeTexts = new Map();
    const NOTICE_CHECK_INTERVAL = 500;
    
    const getNoticeText = (element) => {
        if (!element) return '';
        const textContent = element.textContent || element.innerText || '';
        return textContent.trim();
    };
    
    const isECheckpointNotice = (element) => {
        if (!element) return false;
        if (element.classList && element.classList.contains('wc-block-components-notice-banner')) {
            const text = getNoticeText(element).toLowerCase();
            return text.includes('shipping address is not valid') ||
                   text.includes('billing address is not valid') ||
                   text.includes('u.s. postal service') ||
                   text.includes('usps') ||
                   text.includes('please contact customer service') ||
                   text.includes('preventing checkout') ||
                   text.includes('cannot be shipped');
        }
        return false;
    };
    
    const isNotice = (element) => {
        if (!element || element.nodeType !== 1) {
            return false;
        }
        return element.classList && (
            element.classList.contains('wc-block-components-notice-banner') ||
            element.classList.contains('woocommerce-info') ||
            element.classList.contains('woocommerce-message') ||
            element.classList.contains('woocommerce-error') ||
            element.closest && (
                element.closest('.wc-block-components-notice-banner') ||
                element.closest('.woocommerce-info') ||
                element.closest('.woocommerce-message') ||
                element.closest('.woocommerce-error')
            )
        );
    };
    
    const checkForDuplicate = (element) => {
        if (!element) return false;
        const text = getNoticeText(element);
        if (!text) return false;
        
        const existingNotices = document.querySelectorAll('.wc-block-components-notice-banner, .woocommerce-error, .woocommerce-message, .woocommerce-info');
        for (let i = 0; i < existingNotices.length; i++) {
            const existing = existingNotices[i];
            if (existing !== element) {
                const existingText = getNoticeText(existing);
                if (existingText === text) {
                    return true;
                }
            }
        }
        
        return false;
    };
    
    const originalAppendChild = Node.prototype.appendChild;
    Node.prototype.appendChild = function(child) {
        if (isNotice(child) && checkForDuplicate(child)) {
            return child;
        }
        return originalAppendChild.call(this, child);
    };
    
    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function(newNode, referenceNode) {
        if (isNotice(newNode) && checkForDuplicate(newNode)) {
            return newNode;
        }
        return originalInsertBefore.call(this, newNode, referenceNode);
    };
    
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function(child) {
        if (isNotice(child)) {
            if (isECheckpointNotice(child)) {
                return originalRemoveChild.call(this, child);
            }
            return child;
        }
        return originalRemoveChild.call(this, child);
    };
    
    const originalRemove = Element.prototype.remove;
    Element.prototype.remove = function() {
        if (isNotice(this)) {
            if (isECheckpointNotice(this)) {
                return originalRemove.call(this);
            }
            return;
        }
        return originalRemove.call(this);
    };
})();

